export class CardShippingMethod {
  public feeAmount?: number = 0;
  public shippingLevel?: string = '';
  public label?: string = '';
  public id: string = '';
  public feeName?: string = '';
}
